import { gql, useMutation } from '@apollo/client';
import { useNotifications } from './useNotifications';
import { getRoleAndPermissions } from '../utils/getRoleAndPermissions';

const MARK_AS_READ_MUTATION = gql`
  mutation markAsRead($keyId: Uuid!, $set: Bool!) {
    v2UpdateUserPushNotificationsById(
      keyId: $keyId
      updateColumns: {readStatus: {set: $set}}
    ) {
      affectedRows
    }
  }
`;

export function useNotificationsRead() {
  const { refetch } = useNotifications();
  const { role } = getRoleAndPermissions();

  const [markAsRead] = useMutation(MARK_AS_READ_MUTATION,
    {
      context: {
        headers: {
          'x-hasura-role': role === 'staff' || role === 'super_admin' ? 'staff' : 'learner'
        }
      },
      onCompleted: () => {
        refetch();
      }
    }
  );
  return { markAsRead };
}